import { type Transaction } from '@hooks-api/types/dataModel/fpOrder'
import { createSlice } from '@reduxjs/toolkit'
import { type GiveawayRule } from '../../model/campaign'

export const adminSlice = createSlice({
  name: 'adminContents',
  initialState: {
    order: null as Transaction | null,
    combineOrder: null as Fastpass.CombineOrder | null,
    isNeedCombine: false,
    giveawayRules: null as GiveawayRule[] | null,
  },
  reducers: {
    setOrder: (state, action) => {
      state.order = action.payload
    },

    setCombineOrder: (state, action) => {
      state.combineOrder = action.payload
    },

    setIsNeedCombine: (state, action) => {
      state.isNeedCombine = action.payload
    },

    setGiveawayRules: (state, action: { type: string, payload: GiveawayRule[] }) => {
      state.giveawayRules = action.payload
    },
  },
})

export const { setOrder, setCombineOrder, setIsNeedCombine, setGiveawayRules }
  = adminSlice.actions
export default adminSlice.reducer
